<script lang="ts" setup>
const props = defineProps({
  compact: Boolean,
  isSelected: {
    type: Boolean,
    default: false,
  },
  selectedColor: {
    type: Array as PropType<number[]>,
    default: [0, 0, 0],
  },
  width: {
    type: Number,
    default: 40,
  },
  height: {
    type: Number,
    default: 40,
  },
});

const emit = defineEmits(["selectColor"]);

const colors = computed(() => {
  return [
    // Row 1: Base colors
    [
      [0, 0, 0],
      [255, 0, 0],
      [255, 165, 0],
      [255, 255, 0],
      [0, 128, 0],
      [0, 0, 255],
      [128, 0, 128],
    ],

    // Row 2: Lighter shade 1
    [
      [77, 77, 77],
      [255, 77, 77],
      [255, 192, 77],
      [255, 255, 77],
      [77, 128, 77],
      [77, 77, 255],
      [178, 77, 178],
    ],

    // Row 3: Lighter shade 2
    [
      [128, 128, 128],
      [255, 128, 128],
      [255, 210, 128],
      [255, 255, 128],
      [77, 166, 77],
      [128, 128, 255],
      [192, 128, 192],
    ],

    // Row 4: Darker shade 1
    [
      [51, 51, 51],
      [178, 0, 0],
      [178, 122, 0],
      [178, 178, 0],
      [0, 102, 0],
      [0, 0, 178],
      [102, 0, 102],
    ],

    // Row 5: Darker shade 2
    [
      [26, 26, 26],
      [127, 0, 0],
      [127, 63, 0],
      [127, 127, 0],
      [0, 77, 0],
      [0, 0, 127],
      [77, 0, 77],
    ],
  ];
});

const allColors = computed(() => {
  return colors.value.flat();
});

const selectColor = (color: number[]) => {
  showPicker.value = false;
  emit("selectColor", color);
};

const showPicker = ref(false);

const onHide = () => {
  showPicker.value = false;
};
</script>

<template>
  <span>
    <BasePopover align="start">
      <div
        class="active:bg-opacity-20 flex flex-col items-center justify-center rounded hover:bg-medium-default/10 transition-colors duration-150 cursor-pointer"
        :class="{
          'gap-0.5': compact,
          'mx-1 p-2': !compact,
          'bg-primary-default bg-opacity-20 text-primary-default hover:bg-primary-default':
            isSelected,
        }"
        :style="{
          width: width + 'px',
          height: height + 'px',
        }"
      >
        <icon name="mdi:format-color-text" :size="compact ? 16 : 20" />
        <div
          class="rounded"
          :class="compact ? 'h-0.5 w-4' : 'h-[3px] w-[80%]'"
          :style="{
            'background-color': useArrayToRGB(selectedColor),
          }"
        >
          &nbsp;
        </div>
      </div>
      <template #content>
        <div class="p-1 grid grid-cols-7 grid-rows-5 w-[200px] gap-1">
          <span
            v-for="(color, index) in allColors"
            :key="index"
            class="cursor-pointer hover:opacity-40 rounded"
            :style="{
              'background-color': useArrayToRGB(color),
            }"
            @mousedown.stop.prevent
            @click="selectColor(color)"
          >
            &nbsp;
          </span>
        </div>
        <!-- <div class="p-2 flex flex-col w-[200px] justify-between">
        <div
          v-for="colorRow in colors"
          class="flex flex-row w-full justify-between mb-2"
        >
          <span
            v-for="color in colorRow"
            class="aspect-square w-full"
            :style="{
              'background-color': useArrayToRGB(color),
            }"
            >&nbsp;</span
          >
        </div>
      </div> -->
      </template>
    </BasePopover>
  </span>
</template>

<style scoped></style>
